export default function Intro() {
  return (
    <div className='wrapper'>
      <div className='w-full overflow-x-hidden'>
        <div
          className='h-[340px] bg-no-repeat bg-[#12193d] bg-right-bottom relative'
          style={{
            backgroundImage: 'url(' + require('../assets/images/intro/intro_visual_bg.png') + ')',
          }}
        >
          <img
            src={require('../assets/images/intro/intro_visual.png')}
            alt=''
            className='absolute top-0 left-[calc(50%-34px)] z-[2]'
          />
          <div className='container mx-auto z-[3] relative'>
            <div className='pt-[128px]'>
              <p className='text-default-white text-[18px]'>충남교육청 미래교육 통합플랫폼</p>
              <p className='text-default-white text-[48px] font-[400]'>
                <span className='font-[700]'>마주온</span> 소개
              </p>
            </div>
          </div>
        </div>
        <div className='container flex items-center justify-center mx-auto'>
          <div className='pt-[80px] flex gap-[80px] sm:flex-row flex-col'>
            <p className='text-[30px] font-[700] text-default-black shrink-0'>마주온이란?</p>
            <div className='py-36 border-t-[2px] border-solid border-[#1b2c77]'>
              <p className='text-default-black text-[24px]'>
                <span className='font-[700]'>‘마주온’</span>은 학생, 학부모, 교직원인 교육공동체가
                서로 <span className='text-[#ff8a00] font-[700]'>마주하며</span>
                <br />
                <span className='text-[#37b01b] font-[700]'>온라인(ON)</span>으로 교육에 관한{' '}
                <span className='text-[#00a0e9] font-[700]'>모든(온) 소통</span>을 하는{' '}
                <span>‘충남형 미래교육 통합플랫폼’이다.</span>
              </p>
              <div className='bg-[#f0f3f6] relative max-w-[970px] h-[260px] flex items-center justify-center mt-[60px]'>
                <img
                  src={require('../assets/images/intro/intro_visual_bg2.png')}
                  alt=''
                  className='absolute bottom-0 right-0 z-10'
                />
                <img
                  className='z-20'
                  src={require('../assets/images/intro/intro_img.png')}
                  alt=''
                />
              </div>
              <div className='divide-y-[1px] divide-[#efefef]'>
                <div className='flex items-start py-36'>
                  <p className='text-default-black text-[24px] font-[700] min-w-[115px]'>마주</p>
                  <p className='text-[18px] text-default-header'>
                    1. ‘마주치다’의 의미처럼 비대면이지만 서로 마주보며 실시간 소통하는 교육을
                    원한다는 의미
                    <br />
                    2. ‘마주보다’의 의미처럼 대면과 비대면 교육이 혼합되어 학습을 지원한다는 의미
                    <br />
                    3. ‘마주하다’의 의미처럼 다가오는 미래를 바라보고 준비해 나아가자는 의미
                  </p>
                </div>
                <div className='flex items-start py-36'>
                  <p className='text-default-black text-[24px] font-[700] min-w-[115px]'>온</p>
                  <p className='text-[18px] text-default-header'>
                    1. 소통, 수업, 미래 전체를 뜻하는 온(모든)
                    <br />
                    2. 온라인 ON을 의미하는 중의적인 단어로 이루어짐
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
